import React ,{ createContext, useState, useEffect, useCallback } from 'react';

/*
const initialState = {
   cruntDrawer: '' 
};
*/
  

const DrawerContext = createContext();
  


function DrawerProvider({ children }) {

  const [ currentDrawer, setCurrentDrawer ] = useState('')

  const [ currentProudct , setCurrentProudct  ] = useState('')


  const  initialize = useCallback(()=> {

    const searchParams = new URLSearchParams(window.location.search)

    const openAccordions = [...searchParams.keys()];

    const initDrawer = openAccordions[0]


    if (initDrawer&&typeof initDrawer === 'string'){
      setCurrentDrawer(initDrawer)
    }

    // get proudct
    const initProudct =  searchParams.get('proudct');

    if (initProudct&&typeof initProudct === 'string'){
      setCurrentProudct(initProudct)
    }

  })


  useEffect(()=> {
     initialize()
  }, [initialize])



  function changeDrawer(drawer){
    //if (drawer&&typeof drawer === 'string'){
      setCurrentDrawer(drawer)

      const url = new URL(window.location);

      // clear url
      url.searchParams.forEach(function(value, key) {
        url.searchParams.delete(key);
      });

      // add new param
      url.searchParams.set(drawer, '');
      window.history.pushState({}, '', url);

    //}
  }

  function changeProudct(drawerSlug, proudctSlug) {
    if (drawerSlug&&proudctSlug&&typeof drawerSlug === 'string'&&typeof proudctSlug === 'string'){

      setCurrentDrawer(drawerSlug)


      const url = new URL(window.location);

      // clear url
    //  url.searchParams.forEach(function(value, key) {
     //   url.searchParams.delete(key);
   //   });

      // add new param
      url.searchParams.set('proudct', proudctSlug);
     // url.searchParams.set(drawerSlug, '');
      window.history.pushState({}, '', url);

    }
  }


  return (
    <DrawerContext.Provider
      value={{
        currentDrawer,
        currentProudct,
        initialize,
        changeDrawer,
        changeProudct
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}

export { DrawerProvider, DrawerContext };
